interface PlanDocument {
  title: string;
  url: string;
}

const planDocuments: PlanDocument[] = [
  {
    title: "Plan Rules and Regulations",
    url: "/wp-content/uploads/2018/09/MPF-Restated-Plan-Text-Jan-1-2018.pdf",
  },
  {
    title: "Amendment No. 1",
    url: "/wp-content/uploads/2021/02/Plan-Amendment-No-1-December-2020.pdf",
  },
  {
    title: "Amendment No. 2",
    url: "/wp-content/uploads/2021/02/Plan-Amendment-No-2-December-2020.pdf",
  },
  {
    title: "Amendment No. 3",
    url: "/wp-content/uploads/2021/09/PlanAmendmentNo.3.pdf",
  },
  {
    title: "Amendment No. 4",
    url: "/wp-content/uploads/2022/03/Amendment-4-2021.pdf",
  },
  {
    title: "Amendment No. 5",
    url: "/wp-content/uploads/2022/11/Amendment-No-5.pdf",
  },
];

export default function PlanRulesSection() {
  return (
    <section id="plan-rules" className="w-full bg-white py-16 scroll-mt-14">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Section label */}
        <div className="flex items-center gap-2 mb-3">
          <div className="w-6 h-0.5 bg-[#1a8fc1]"></div>
          <span className="text-[#1a8fc1] text-xs font-semibold tracking-widest uppercase">
            Governing Documents
          </span>
        </div>

        {/* Heading with icon */}
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white border border-gray-100">
            <i className="ri-book-2-line text-lg text-[#0d1f4c]"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-[#0d1f4c]">
            Plan Rules
          </h2>
        </div>

        {/* Body text */}
        <p className="text-sm text-gray-500 leading-relaxed max-w-[720px]">
          The Plan Rules and Regulations are the official governing documents of the Musicians&rsquo; Pension Fund of Canada. They set out the legal terms, eligibility criteria, benefit provisions, and administrative procedures that govern the operation of the Fund.
        </p>

        {/* Document list */}
        <div className="mt-6">
          <div className="bg-[#f8fafc] rounded-lg border border-gray-200 border-t-[3px] border-t-[#1a8fc1] shadow-sm overflow-hidden">
            {planDocuments.map((doc, index) => (
              <div
                key={index}
                className="flex items-center gap-3 py-2.5 px-5 border-b border-gray-100 last:border-b-0 hover:bg-white/60 transition-colors duration-150"
              >
                {/* Document icon */}
                <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-md bg-[#e8f4fb]">
                  <i className="ri-file-pdf-2-line text-sm text-[#1a8fc1]"></i>
                </div>

                {/* Document title */}
                <h3 className="flex-1 min-w-0 text-sm font-medium text-[#0d1f4c] truncate">
                  {doc.title}
                </h3>

                {/* View button */}
                <a
                  href={doc.url}
                  target="_blank"
                  rel="nofollow"
                  className="inline-flex items-center gap-1 px-3.5 py-1.5 text-xs font-medium text-[#1a8fc1] border border-[#1a8fc1] rounded-md hover:bg-[#e8f4fb] transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
                >
                  View
                  <i className="ri-external-link-line text-xs"></i>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}